import { getAdvanced } from '../../utils'

const configAggregator = (node) => {
    node.querySelectorAll('img').forEach((img) => {
        img.setAttribute('loading', 'lazy')
    })
    return {
        content: node.innerHTML,
        ...getAdvanced(node)
    }
}

export default configAggregator
